import { SmileLivenessCallback } from "@innovatrics/dot-smile-liveness";
import styles from "../../../../../styles/index.module.css";
import commonStyles from "../../../../../styles/common.module.css";
import buttonStyles from "../../../../../styles/button.module.css";
import SmileLivenessCamera from "./SmileLivenessCamera";
import SmileLivenessUi from "./SmileLivenessUi";
import {
  ControlEventInstruction,
  dispatchControlEvent,
} from "@innovatrics/dot-document-auto-capture/events";
import { FaceCustomEvent } from "@innovatrics/dot-face-auto-capture/events";
import Image from "../../../../common/Image";
import { useState } from "react";
import ProcessingDescription from "../../../common/ProcessingDescription";
import { useTranslation } from "react-i18next";

interface Props {
  onComplete: SmileLivenessCallback;
  onError: (error: Error) => void;
  onBackClick: () => void;
  smileIndex: number;
  setSmileIndex: React.Dispatch<React.SetStateAction<number>>;
  photoUrl: string | undefined;
  setPhotoUrl: React.Dispatch<React.SetStateAction<string | undefined>>;
  isRetryButtonDisabled: boolean;
  setIsRetryButtonDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  processing:boolean
}

function SmileLiveness({
  onBackClick,
  onComplete,
  onError,
  photoUrl,
  setPhotoUrl,
  setSmileIndex,
  isRetryButtonDisabled,
  setIsRetryButtonDisabled,
  processing
}: Props) {
  const {t} = useTranslation();
  const smileUIInstructions = {
    candidate_selection:t('liveness.capture.staystill'),
    face_too_close:t('liveness.capture.moveback'),
    face_too_far:t('liveness.capture.movecloser'),
    face_centering:t('liveness.capture.centeryourface'),
    face_not_present:t('liveness.capture.positionyourface'),
    left_eye_not_present:t('liveness.capture.positionyourface'),
    right_eye_not_present:t('liveness.capture.positionyourface'),
    mouth_not_present:t('liveness.capture.positionyourface'),
    sharpness_too_low:t('liveness.capture.turntolight'),
    brightness_too_low:t('liveness.capture.turntolight'),
    brightness_too_high:t('liveness.capture.lesslight'),
    device_pitched:t('liveness.capture.holdateyelevel'),
    smile:t('liveness.capture.smile'),
    smile_candidate_selection:t('liveness.capture.smile'),
    keep_neutral_expression:t('liveness.capture.keepneutral')
  }
  const appStateInstructions = {
    loading: { text: t('liveness.active.capture.loading'), visible: true },
    done: {
      text: t('processing'),
      visible: true,
    },
  };
  const handleContinueDetection = () => {
    setSmileIndex((prev) => Math.max(prev + 1, 0));
    setPhotoUrl(undefined);
    setIsRetryButtonDisabled(true);
    dispatchControlEvent(
      FaceCustomEvent.CONTROL,
      ControlEventInstruction.CONTINUE_DETECTION
    );
  };

  const sessionToken = sessionStorage.getItem("sessionToken") as string;

  return (
    <>
      <h1  className={commonStyles.header}>{t('liveness.active.capture.header')}</h1>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection:"column",
          gap: "5px",
        }}
      >
      <div className={styles.container}>
        <SmileLivenessCamera onComplete={onComplete} onError={onError} sessionToken={sessionToken}/>
        <SmileLivenessUi
          showCameraButtons
          appStateInstructions={appStateInstructions}
          instructions={smileUIInstructions}
        />
        <div className={commonStyles.popup}>
          {photoUrl && (
            <Image src={photoUrl} className={commonStyles.popupImg}></Image>
          )}
        </div>
      </div>
      {processing && photoUrl && (<ProcessingDescription content={t('liveness.capture.processing.description')} />)}
      </div>
    </>
  );
}

export default SmileLiveness;
